<div class="marketing-popup-container">
  <div class="marketing-popup-content">
    <h3 class="marketing-popup-content__title">
      {{ (customVariables$ | async)?.slider_marketing_title }}
    </h3>
    <div class="marketing-popup-content__img">
      <ng-container *ngIf="marketingImage$ | async as marketingImage; else defaultMarketingImage">
        <img [src]="marketingImage.file" [alt]="marketingImage.alt" [title]="marketingImage.title" />
      </ng-container>
      <ng-template #defaultMarketingImage>
        <img class="marketing-popup-content__img--default" alt="marketing image" />
      </ng-template>
    </div>

    <div class="marketing-popup-content__description">
      <ng-container *ngIf="step === 1">
        <h3 [innerHTML]="(customVariables$ | async)?.slider_marketing_description"></h3>
      </ng-container>
      <ng-container *ngIf="step === 2">
        <h3>{{ (customVariables$ | async)?.slider_marketing_signup_success }}</h3>
      </ng-container>
    </div>
  </div>

  <div class="marketing-popup-buttons" [ngClass]="{ 'marketing-popup-buttons--step-1': step === 1 }">
    <ng-container *ngIf="step === 1">
      <button mat-raised-button (click)="clickButton(buttonTypes.DISAGREED)">
        <span [translate]="'SliderMarketing:NoThanks'">No, thanks</span>
      </button>
      <button mat-raised-button color="primary" (click)="clickButton(buttonTypes.AGREED)">
        <span [translate]="'SliderMarketing:YesPlease'">Yes please!</span>
      </button>
    </ng-container>

    <ng-container *ngIf="step === 2">
      <button mat-raised-button color="primary" (click)="clickButton(buttonTypes.CONTINUE)">
        <span [translate]="'SliderMarketing:Continue'">Continue</span>
      </button>
    </ng-container>
  </div>
</div>
